import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { ajaxPreUrl } from '@/config';

/**
 * @description 获取kugou音乐模块列表
 * @param {Object} params
 * params:{
 *  projectId,  (项目Id)
 *  celebrityId, (艺人主页Id)
 * } // 传入其中一个参数就可以
 */
export var getkugouMusicList = /*#__PURE__*/function () {
  var _getkugouMusicList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axios.get("".concat(ajaxPreUrl, "/celebritySongs/listByProjectId"), {
            params: params
          });
        case 2:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  function getkugouMusicList(_x) {
    return _getkugouMusicList.apply(this, arguments);
  }
  return getkugouMusicList;
}();